import apiService from "@/lib/api";

const WEBSOCKET_BASE = "/api/v2/websocket";

export const WebsocketService = {
  /**
   * A single-use, 30-second credential for the socket handshake. The error is
   * not swallowed: the transport reconnects once on a rejected ticket and
   * stops on the second refusal, and it can only do that if it hears about
   * the failure.
   */
  mintTicket: async () => {
    const response = await apiService.postSecure(`${WEBSOCKET_BASE}/ticket`);
    return response.data?.data?.ticket;
  },

  /**
   * A `link` ticket for the compliance portal, minted against the magic-link
   * token instead of a session.
   *
   * `post`, not `postSecure`: the visitor has no JWT to attach, and the token
   * in the path is their whole credential. It lives beside `mintTicket`
   * rather than in `complianceService` because both answer one question — how
   * this tab gets a ticket — and `lib/websocket.js` should import one module
   * for it, not two.
   */
  mintPortalTicket: async (token) => {
    const response = await apiService.post(`/api/v2/compliance/portal/${token}/websocket-ticket`);
    return response.data?.data?.ticket;
  },
};

export default WebsocketService;
